/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactIdMapping
 */
export interface ContactIdMapping {
    /**
     * 
     * @type {string}
     * @memberof ContactIdMapping
     */
    oldId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactIdMapping
     */
    newId?: string;
}

/**
 * Check if a given object implements the ContactIdMapping interface.
 */
export function instanceOfContactIdMapping(value: object): value is ContactIdMapping {
    return true;
}

export function ContactIdMappingFromJSON(json: any): ContactIdMapping {
    return ContactIdMappingFromJSONTyped(json, false);
}

export function ContactIdMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactIdMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'oldId': json['oldId'] == null ? undefined : json['oldId'],
        'newId': json['newId'] == null ? undefined : json['newId'],
    };
}

export function ContactIdMappingToJSON(json: any): ContactIdMapping {
    return ContactIdMappingToJSONTyped(json, false);
}

export function ContactIdMappingToJSONTyped(value?: ContactIdMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oldId': value['oldId'],
        'newId': value['newId'],
    };
}

